let { View } = window.App;

const SELECTOR = '.js-modal';

class Modal{
    constructor( el ){
        this.el = el;
        this.$el = $( el );

        let $close = this.$el.find( SELECTOR + "__close" );

        $close.on( 'click', $.proxy( this.closeModal, this ) );
    }

    closeModal( e ){
        e.preventDefault();
        this.$el.fadeOut( 300, _ => this.$el.remove() );
    }
}

View.addHook( 'init', _ => {
    $( SELECTOR ).each( function(){
        new Modal( this );
    } );

    $( '.js-modal-link' ).on( 'click', function( e ){
        e.preventDefault()

        let modal_html = $( e.currentTarget.hash ).html();
        let $modal = $( '<div>' ).html( modal_html ).appendTo( 'body' );
        new Modal( $modal.get( 0 ) );
    } );
} );



// WEBPACK FOOTER //
// ./resources/assets/js/modules/modal.js